import React from "react";
import { Icon, Typography, RaiseColors, IconConstants, makeStyles } from "componentLibrary";
import { Chip as MuiChip } from "@mui/material";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
var useStyles = makeStyles(function () {
  return {
    chip: {
      backgroundColor: RaiseColors.science200,
      border: "1px solid ".concat(RaiseColors.science900)
    },
    disabledChip: {
      backgroundColor: RaiseColors.grayscale200,
      border: "1px solid ".concat(RaiseColors.grayscale300)
    },
    chipLabel: {
      color: "".concat(RaiseColors.science900, " !important")
    },
    disabledChipLabel: {
      color: "".concat(RaiseColors.grayscale900, " !important")
    }
  };
});
var Chip = function Chip(_ref) {
  var label = _ref.label,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    onDelete = _ref.onDelete;
  var classes = useStyles();
  return /*#__PURE__*/_jsx(MuiChip, {
    className: disabled ? classes.disabledChip : classes.chip,
    tabIndex: -1,
    label: /*#__PURE__*/_jsx(Typography, {
      variant: "paragraph_small",
      className: disabled ? classes.disabledChipLabel : classes.chipLabel,
      children: label
    }),
    onDelete: onDelete,
    deleteIcon: disabled ? /*#__PURE__*/_jsx(_Fragment, {}) : /*#__PURE__*/_jsx(Icon, {
      color: RaiseColors.science900,
      style: {
        marginRight: "10px"
      },
      fontSize: "16px",
      className: IconConstants.X
    })
  });
};
export default Chip;